import { Checkbox, Col, Divider, Row } from 'antd'
import { CheckboxValueType } from 'antd/lib/checkbox/Group'
import React from 'react'
import { ICheckboxGroupProps } from './types'

function CheckBoxGroup(props: ICheckboxGroupProps) {
  return (
    <Checkbox.Group
      value={props.value}
      onChange={(e) => props.onChange(e)}
    >
      <Row key={props.options + props.checkboxName}>
        {props.options && props.options.map((item: any) => (
          <>
            <Col
              key={item.id}
              span={24}
            >
              <Checkbox
                id={item.id + '-' + item[props.checkboxName]}
                value={item.id}
              > &nbsp;
              </Checkbox>
              {item[props.checkboxName] && item[props.checkboxName]}
            </Col>
          </>
        ))}
        {!props.options || props.options.length === 0 && (
          <strong>{props.emptyMessage ? props.emptyMessage : 'This list is empty'}</strong>
        )}
      </Row>
    </Checkbox.Group>
  )
}

export default CheckBoxGroup